import axios from "axios";
import { baseURL } from "@/general";
axios.defaults.baseURL = baseURL;
import {
  userLogin,
  registerExamen,
  getExamenTitulacion,
  verificaAcceso,
  validaAvisoPrivacidad,
  registraExamenTitulacionAlumno,
  obtainRecursosVisuales,
  incribirGrupoAlumno,
  validExamenActivo,
  validGrupoActivo,
  verifyNivelInicial,
  verifyAsignaturasAlumno,
  getInscripcionCursos,
  getGruposByAsignatura,
  getPeriodoInscripcion,
  getComprobanteInscripcion,
  getInformacionExamenTitulacionAlumnos,
  getRegistrosExamenesTitulacionBySemestreAlumno,
  getEncuestaAlumno,
  getGuiaAccesoExamenTitulacion,
  insertarRespuestaEncuesta,
  validaDatosAlumno,
  editarCorreoAlumno,
  getInformacionExamenPosgradoAlumnos,
  getRegistrosExamenesPosgradoBySemestreAlumno,
  registraExamenPosgradoAlumno
} from "@/modules/user/helpers/services";

export const validaExamenActivo = async ({ commit }, values) => {
  const { data } = await validExamenActivo(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const validaGrupoActivo = async ({ commit }, values) => {
  const { data } = await validGrupoActivo(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const registroAExamenAlumno = async ({ commit }, values) => {
  const { data } = await registraExamenTitulacionAlumno(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const verifyUser = async ({ commit }, values) => {
  const { data } = await userLogin(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const registerExamenTitulacion = async ({ commit }, values) => {
  const { data } = await registerExamen(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const inscribirCursoTaller = async ({ commit }, values) => {
  const { data } = await incribirGrupoAlumno(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const generarComprobanteInscripcion = async ({ commit }, values) => {
  const { data } = await getComprobanteInscripcion(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};



export const traeExamenTitulacion = async ({ commit }) => {
  const { data } = await getExamenTitulacion();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const verificaSesion = async ({ commit }, values) => {
  const { data } = await verificaAcceso(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const obtenAvisoPrivacidad = async ({ commit }, values) => {
  const { data } = await validaAvisoPrivacidad(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const obtenerRecursosVisuales = async ({ commit }, values) => {
  const { data } = await obtainRecursosVisuales(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const cambiarPassword = async ({ commit }, values) => {
  const { data } = await changePassword(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const validaNivelInicial = async ({ commit }, values) => {
  const { data } = await verifyNivelInicial(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};


export const validaAsignaturasAlumno = async ({ commit }) => {
  const { data } = await verifyAsignaturasAlumno();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const traeInscripcionCursos = async ({ commit }) => {
  const { data } = await getInscripcionCursos();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const traeGruposPorAsignatura = async ({ commit }, values) => {
  const { data } = await getGruposByAsignatura(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const traePeriodoInscripcion = async ({ commit }) => {
  const { data } = await getPeriodoInscripcion();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};


export const traeInformacionExamenTitulacionAlumnos = async ({ commit }, values) => {
  const { data } = await getInformacionExamenTitulacionAlumnos(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};


export const traeRegistrosExamenesTitulacionBySemestreAlumno = async ({ commit }, values) => {
  const { data } = await getRegistrosExamenesTitulacionBySemestreAlumno(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const traeEncuestaAlumno = async ({ commit }, values) => {
  const { data } = await getEncuestaAlumno(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const traeGuiaAccesoExamenTitulacion = async ({ commit },) => {
  const { data } = await getGuiaAccesoExamenTitulacion();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};


export const guardarRespuestasEncuesta = async ({ commit }, values) => {
  const { data } = await insertarRespuestaEncuesta(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const validacionDatosAlumno = async ({ commit }, ) => {
  const { data } = await validaDatosAlumno();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};


export const cambiarCorreoAlumno = async ({ commit }, values) => {
  const { data } = await editarCorreoAlumno(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};








export const traeInformacionExamenPosgradoAlumnos = async ({ commit }, values) => {
  const { data } = await getInformacionExamenPosgradoAlumnos(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};



export const traeRegistrosExamenesPosgradoBySemestreAlumno = async ({ commit }, values) => {
  const { data } = await getRegistrosExamenesPosgradoBySemestreAlumno(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};


export const registroAExamenPosgradoAlumno = async ({ commit }, values) => {
  const { data } = await registraExamenPosgradoAlumno(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};